export default "__VITE_ASSET__Cd5BhBc___"